import React from "react";
import { FaWhatsapp as WhatsappIcon } from "@react-icons/all-files/fa/FaWhatsapp";
import { FaTelegramPlane as TelegramIcon } from "@react-icons/all-files/fa/FaTelegramPlane";
import { CONTACT_KEYS, FAVICON_ICON_ROUTE } from "@Utils";
import styles from "../common/ContactWidget/contactWidget.module.scss";
import {
    USER_COLORS,
    RANDOM_INDEX,
    LANDING_PAGE_URL,
} from "./contactWidgetFloatModal.constant";
import { IContactWidgetFloat } from "./IContactWidgetFloat";

const ContactWidgetFloatModal = (props: IContactWidgetFloat) => {
    const { isOpen, hostData, setOpen, isTelegram } = props;

    // if whatsapp contact link contains + than replace by empty string
    const contactUrl =
        hostData.contact_mode === CONTACT_KEYS.Whatsapp &&
        hostData.contact_url?.includes("+")
            ? hostData.contact_url?.replace("+", "")
            : hostData.contact_url;
    return (
        <div>
            {isOpen ? (
                <div className={styles.chatContainer}>
                    <div className={styles.header}>
                        <img
                            className={styles.profilePic}
                            alt=""
                            src={hostData.profile_pic || FAVICON_ICON_ROUTE}
                        />
                        <div className={styles.headerContent}>
                            <div
                                className={`${styles.lineMax1} ${styles.title}`}
                            >
                                {hostData.name}
                            </div>
                            <div
                                className={`${styles.lineMax1} ${styles.description} mt-1`}
                            >
                                {hostData.title}
                            </div>
                        </div>
                        <div
                            className={styles.close}
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            &times;
                        </div>
                    </div>
                    <div className={styles.body}>
                        <div className={styles.chatItem}>
                            <div
                                className={`${styles.chatName} ${styles.lineMax1}`}
                                style={{
                                    color: USER_COLORS[RANDOM_INDEX],
                                }}
                            >
                                {hostData.name}
                            </div>
                            <div className={styles.chatText}>
                                Hi, there! <br /> How can I help you?
                            </div>
                        </div>
                    </div>
                    <div className={styles.footer}>
                        <a
                            href={contactUrl}
                            target="_blank"
                            rel="noreferrer noopener"
                            className={styles.ctaButton}
                        >
                            <span className={styles.ctaIcon}>
                                {isTelegram ? (
                                    <TelegramIcon />
                                ) : (
                                    <WhatsappIcon />
                                )}
                            </span>
                            <span>Start Chat</span>
                        </a>
                        <div className={styles.branding}>
                            ⚡ by{" "}
                            <a
                                href={`https://${LANDING_PAGE_URL}`}
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                {LANDING_PAGE_URL}
                            </a>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default ContactWidgetFloatModal;
